import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Accommodation, Insurance, ProfessionalImmersionExperience, Transfer, TransferServiceType } from '@lx/shared/data-access/products';
import { AccommodationComponent } from '../../../accommodation/accommodation.component';
import { InsuranceComponent } from '../../../insurance/insurance.component';
import { ProfessionalImmersionExperienceComponent } from '../../../professional-immersion-experience/professional-immersion-experience.component';
import { TransfersComponent } from '../../../transfers/transfers.component';

@Component({
  standalone: true,
  selector: 'lx-quote-step-adults-extras',
  templateUrl: './quote-step-adults-extras.component.html',
  styleUrls: ['./quote-step-adults-extras.component.scss'],
  imports: [AccommodationComponent, TransfersComponent, InsuranceComponent, NgIf, ProfessionalImmersionExperienceComponent],
})
export class QuoteStepAdultsExtrasComponent {
  @Input() insurance: Insurance | undefined;
  @Input() accommodations: Accommodation[];
  @Input() accommodationOptional: boolean | undefined;
  @Input() moreAccommodationsDisclaimerShown: boolean | undefined;
  @Input() groupedTransfers: Record<TransferServiceType, Transfer[]> | undefined;
  @Input() professionalImmersionExperience: ProfessionalImmersionExperience | undefined;
}
